module.exports = __webpack_public_path__ + "img/kv_6_1.fa92f63c.png";